import { render, staticRenderFns } from "./RsaConfigurazioneMenuPazienteListPage.vue?vue&type=template&id=06a79c56"
import script from "./RsaConfigurazioneMenuPazienteListPage.vue?vue&type=script&lang=js"
export * from "./RsaConfigurazioneMenuPazienteListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports